// Hooks
import { forwardRef } from 'react';

// Next
import Image from 'next/image';

// Contentful
import { imageLoader } from '../../helpers/contentful';

const CarouselItem = forwardRef((props, ref) => {
  const {
    fields: { largeMedia, smallMedia },
  } = props;

  return (
    <div className="CarouselItem" ref={ref}>
      {largeMedia && !smallMedia && (
        <div className="CarouselItem-image">
          <Image
            layout="responsive"
            lazyBoundary="500px"
            loader={imageLoader}
            alt={largeMedia.fields.description}
            src={`https:${largeMedia.fields.file.url}`}
            height={largeMedia.fields.file.details.image.height}
            width={largeMedia.fields.file.details.image.width}
          />
        </div>
      )}

      {largeMedia && smallMedia && (
        <>
          <div className="CarouselItem-image CarouselItem-image--mobile">
            <Image
              layout="responsive"
              lazyBoundary="500px"
              loader={imageLoader}
              alt={largeMedia.fields.description}
              src={`https:${smallMedia.fields.file.url}`}
              height={smallMedia.fields.file.details.image.height}
              width={smallMedia.fields.file.details.image.width}
            />
          </div>
          <div className="CarouselItem-image CarouselItem-image--desktop">
            <Image
              layout="responsive"
              lazyBoundary="500px"
              loader={imageLoader}
              alt={largeMedia.fields.description}
              src={`https:${largeMedia.fields.file.url}`}
              height={largeMedia.fields.file.details.image.height}
              width={largeMedia.fields.file.details.image.width}
            />
          </div>
        </>
      )}
    </div>
  );
});

export default CarouselItem;
